import { Button, Card, Flex, Form, Input, Modal, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEnviarCodigo } from "../../../Hooks/Player";

export const Botonera = () => {
  const navigate = useNavigate();
  const apiEnviarCodigo = useEnviarCodigo();
  const [modalCodigo, setModalCodigo] = useState(false);
  const handleLogout = () => {
    localStorage.clear();

    window.history.pushState({}, "", "/login");
    window.location.reload();
  };
  return (
    <Card
      hoverable
      style={{
        marginTop: "2rem",
        width: "90vw",
        backgroundColor: "rgba(255, 255, 255, 0)",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.8)",
        border: "none",
      }}
      styles={{
        body: { padding: 0, overflow: "hidden", borderRadius: "0.5rem" },
      }}
    >
      <Flex
        align="center"
        gap="middle"
        vertical
        style={{
          padding: 20,

          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
      >
        <Button style={{ width: "100%" }} onClick={() => setModalCodigo(true)}>
          INGRESAR CÓDIGO
        </Button>
        <Button
          style={{ width: "100%" }}
          onClick={() => navigate("/configuracion/logros")}
        >
          MIS LOGROS
        </Button>

        <Button
          style={{ width: "100%" }}
          onClick={() => navigate("/configuracion/perfil")}
        >
          EDITAR PERFIL
        </Button>
        <Button
          type="primary"
          style={{ width: "100%", marginTop: "5rem" }}
          danger
          onClick={() => {
            Modal.confirm({
              title: "Cerrar Sesión",
              content: "¿Seguro que quiere cerrar sesión?",
              footer: (_, { OkBtn, CancelBtn }) => (
                <>
                  <CancelBtn />
                  <OkBtn />
                </>
              ),
              onOk: handleLogout,
            });
          }}
        >
          CERRAR SESIÓN
        </Button>
      </Flex>

      <Modal
        title="INGRESAR CÓDIGO"
        open={modalCodigo}
        footer={null}
        onCancel={() => setModalCodigo(false)}
      >
        <Form
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          onFinish={async (e) => {
            const respuesta = await apiEnviarCodigo.mutateAsync(e);
            localStorage.removeItem("pokedex");

            if(respuesta.datos.tipo == "pokemon"){
              navigate("/gashapon", {
                state: {
                  pokeNombre: respuesta.datos.canje.pokeNombre,
                  pokeImagen: respuesta.datos.canje.pokeImagen,
                },
              });
            }else if (respuesta.datos.tipo == "objeto") {
              navigate("/cupones", {
                state: respuesta.datos.canje,
              });
            }
           
          }}
        >
          <Form.Item
            name="codigo"
            label="Código"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button htmlType="submit" type="primary">
                Enviar
              </Button>
              <Button htmlType="reset">Borrar</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};
